import { NotifyHelper } from "../../../helpers/toast";
import { eCategoryMenuActionTypeDefine } from "../../action-types/category/ICategoryMenuActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const categoryMenuActions = {
    ...generateActions(eCategoryMenuActionTypeDefine, "CATEGORY_MENU"),
    ...generateActionForKey(eCategoryMenuActionTypeDefine, "CATEGORY_MENU", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eCategoryMenuActionTypeDefine, "CATEGORY_MENU", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eCategoryMenuActionTypeDefine, "CATEGORY_MENU", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eCategoryMenuActionTypeDefine, "CATEGORY_MENU", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}

